// import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import { Result, Space, Typography } from 'antd';
import EnquirySubmittedIcon from 'assets/images/enquiry-submitted-icon.svg';

// import { useEnquiryEmailSubmission } from 'all-in-one-shared-api';
import { PrimaryButton } from 'components';
// import { useKeycloakReady } from 'hooks/useKeycloakReady';

interface EnquiryData {
  enquiryReference: string;
}

export const EnquirySuccessPage = ({ enquiryReference }: EnquiryData) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const { ready, token } = useKeycloakReady();

  // const { shouldFetch: shouldPostEnquiryEmailSubmission } = useEnquiryEmailSubmission(
  //   { key: 'enquiryEmailSubmission', enquiryReference: enquiryReference },
  //   token ?? '',
  //   enquiryReference,
  //   {
  //     shouldRetryOnError: false,
  //     revalidateOnFocus: false,
  //   },
  // );

  // useEffect(() => {
  //   if (ready && enquiryReference) {
  //     shouldPostEnquiryEmailSubmission(true);
  //   }
  // }, [shouldPostEnquiryEmailSubmission, enquiryReference, ready]);

  if (!enquiryReference) {
    return <Navigate to="/notFound" replace={true} />;
  }

  return (
    <Result
      icon={<img src={EnquirySubmittedIcon} />}
      title={t('enquiry.success.message')}
      subTitle={`${t('enquiry.success.reference', { referenceNumber: enquiryReference })}`}
      extra={
        <Space direction="vertical">
          <Typography.Text>{t('benefits.surgery.description')}</Typography.Text>
          <PrimaryButton onClick={() => navigate('/home')}>{t('common.error.returnHome')}</PrimaryButton>
        </Space>
      }
    />
  );
};
